import { render, staticRenderFns } from "./VwShowDisplayIndex.vue?vue&type=template&id=76b16be5&lang=pug&"
import script from "./VwShowDisplayIndex.vue?vue&type=script&lang=ts&"
export * from "./VwShowDisplayIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VwShowDisplayIndex.vue"
export default component.exports